import genericWidget from '@components/mixins/genericWidget'
import fortuneWheelSpecific from '@components/mixins/shared/widgets/fortuneWheel'
import Wheel from '@components/Widgets/_contentItems/FortuneWheel/FortuneWheel.vue'

export default {
  name: 'FortuneWheelWidget',
  components: {
    'wheel-component': Wheel,
  },
  mixins: [genericWidget, fortuneWheelSpecific],
  created() {
    if (this.isPreview) {
      this.registerWheelEventBusEvents()
    }
  },
  methods: {
    isEditable(contentItem) {
      if (contentItem.type === 'voucher') {
        return false
      } else if (contentItem.type === 'button' && contentItem.settings.action === 'wheelSpin') {
        return false
      }

      return true
    },
  },
}
